__turbopack_context__.v({
  "container": "NewsPage-module-scss-module__cpKILW__container",
  "emptyState": "NewsPage-module-scss-module__cpKILW__emptyState",
  "loadMoreWrapper": "NewsPage-module-scss-module__cpKILW__loadMoreWrapper",
  "loading": "NewsPage-module-scss-module__cpKILW__loading",
  "loadingContainer": "NewsPage-module-scss-module__cpKILW__loadingContainer",
  "newsGrid": "NewsPage-module-scss-module__cpKILW__newsGrid",
  "newsPage": "NewsPage-module-scss-module__cpKILW__newsPage",
  "pageTitle": "NewsPage-module-scss-module__cpKILW__pageTitle",
});
